export interface TypeScale {
  element: string;
  font: 'Work Sans' | 'Poppins';
  sizePx: number;
  weight: 300 | 400 | 500 | 600;
  case: 'uppercase' | 'sentence';
  sample: string;
}

/**
 * ATEK typography v2.1 (Dec 2025).
 * Source: 03 Reference/ATEK Brand/01_Brand_Marketing_Guide.md §3 Typography
 */
export const TYPE_FAMILIES: { name: 'Work Sans' | 'Poppins'; role: string; notes: string }[] = [
  { name: 'Work Sans', role: 'Headlines', notes: 'Light (300), uppercase preferred.' },
  { name: 'Poppins',   role: 'Body',      notes: 'Regular (400).' },
];

export const TYPE_SCALE: TypeScale[] = [
  { element: 'H1',    font: 'Work Sans', sizePx: 48, weight: 300, case: 'uppercase', sample: 'Monitoring Made Simple' },
  { element: 'H2',    font: 'Work Sans', sizePx: 36, weight: 300, case: 'uppercase', sample: 'We’ve got your back' },
  { element: 'H3',    font: 'Work Sans', sizePx: 28, weight: 300, case: 'sentence',  sample: 'Protective wisdom, technical expertise' },
  { element: 'Body',  font: 'Poppins',   sizePx: 18, weight: 400, case: 'sentence',  sample: 'ATEK embodies the Caregiver-Sage archetype — protective wisdom combined with technical expertise.' },
  { element: 'Small', font: 'Poppins',   sizePx: 14, weight: 400, case: 'sentence',  sample: 'Small print, metadata, captions.' },
];
